<template>
  <div id="EditShipment">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Atualizar Dados do Embarque</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>
          <v-row v-if="open">
            <v-col cols="12" md="6">
              <v-text-field v-model="freightPrice" label="Preço do Frete" v-money="money"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="totalMileage"
                label="Quilometragem total"
                v-money="totalMileageMask"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="advanceAmount" label="Valor do adiantamento" v-money="money"></v-text-field>
            </v-col>
          </v-row>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close(false, null)"> Cancelar </v-btn>
          <v-btn :disabled="buttonDisable" color="success" class="flex-grow-1" large @click="sendEditShipment()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import removePriceMask from '../../utils/removePriceMask';
import { mapActions } from 'vuex';
import { VMoney } from 'v-money';
import { stringToMoneyMask } from '@/handlers/MoneyHandler';
export default {
  name: 'EditShipment',
  props: {
    open: {
      default: false,
      type: Boolean
    },
    shipment: {
      default: null,
      type: Object
    }
  },
  directives: { money: VMoney },
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    totalMileageMask: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '',
      precision: 0,
      masked: false /* doesn't work with directive */
    },
    freightPrice: '',
    totalMileage: '',
    advanceAmount: '',
    message: []
  }),
  watch: {
    open(val) {
      this.freightPrice = '';

      if (val) {
        if (this.freightPrice === '') {
          this.freightPrice = stringToMoneyMask(this.shipment.freightPrice);
          this.totalMileage = this.shipment.totalMileage.replace(',00', '').replace(',', '.');
          this.advanceAmount = stringToMoneyMask(this.shipment.advanceAmount);
        }
      }
    }
  },
  computed: {
    buttonDisable() {
      return this.freightPrice.length === 0 || this.totalMileage.length === 0;
    }
  },
  methods: {
    ...mapActions('ShipmentStore', ['fetchEditShipment', 'fetchShipmentByID']),

    async sendEditShipment() {
      this.transformPrice();

      const params = {
        id: this.shipment.id,
        totalMileage: Number(this.totalMileage),
        freightPrice: Number(this.freightPrice),
        advanceAmount: Number(this.advanceAmount)
      };
      try {
        const data = await this.fetchEditShipment(params);
        if (data.success) {
          this.message = {
            errors: ['Alterações realizadas com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: data.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(true, this.message);
      }
    },
    transformPrice() {
      this.freightPrice = removePriceMask(this.freightPrice);
      this.totalMileage = removePriceMask(this.totalMileage);
      this.advanceAmount = removePriceMask(this.advanceAmount);
    },
    close(hasChange, message) {
      this.$emit('closeEditShipment', hasChange, message);
    }
  }
};
</script>

<style></style>
